import { gql } from '@src/lib/gql'

export const WITHDRAW_BOARD_INVITE = gql`
  mutation WithdrawBoardInvite($input: WithdrawBoardInviteInput!) {
    withdrawBoardInvite(input: $input) {
      advisorEngagement {
        id
        advisorEngagementId
        statusKey
        invitedAt
        advisorUserId
        advisorName
        advisorEmail
        status {
          id
          key
          title
        }
      }
    }
  }
`
